var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.675 3.26L3.26 11.675C2.86 11.165 2.55 10.6 2.33 9.98C2.11 9.34 2 8.68 2 8C2 6.91 2.275 5.9 2.825 4.97C3.355 4.07 4.07 3.355 4.97 2.825C5.9 2.275 6.91 2 8 2C8.68 2 9.34 2.11 9.98 2.33C10.6 2.55 11.165 2.86 11.675 3.26ZM4.325 12.74L12.74 4.325C13.14 4.835 13.45 5.4 13.67 6.02C13.89 6.66 14 7.32 14 8C14 9.09 13.725 10.1 13.175 11.03C12.645 11.93 11.93 12.645 11.03 13.175C10.1 13.725 9.09 14 8 14C7.32 14 6.66 13.89 6.02 13.67C5.4 13.45 4.835 13.14 4.325 12.74ZM8 0.5C6.98 0.5 6.005 0.695001 5.075 1.085C4.185 1.465 3.3925 2.0025 2.6975 2.6975C2.0025 3.3925 1.465 4.185 1.085 5.075C0.695 6.005 0.5 6.98 0.5 8C0.5 9.02 0.695 9.995 1.085 10.925C1.465 11.815 2.0025 12.6075 2.6975 13.3025C3.3925 13.9975 4.185 14.535 5.075 14.915C6.005 15.305 6.98 15.5 8 15.5C9.02 15.5 9.995 15.305 10.925 14.915C11.815 14.535 12.6075 13.9975 13.3025 13.3025C13.9975 12.6075 14.535 11.815 14.915 10.925C15.305 9.995 15.5 9.02 15.5 8C15.5 6.98 15.305 6.005 14.915 5.075C14.535 4.185 13.9975 3.3925 13.3025 2.6975C12.6075 2.0025 11.815 1.465 10.925 1.085C9.995 0.695001 9.02 0.5 8 0.5Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.6d413eeacebf35e60f6a9c6c822fbe88.svg";
export { ForwardRef as ReactComponent };